export default __webpack_public_path__ + "media/images/feature_design-7338ccb0efbb46980bb7b0cda8bed2ff.png";